export const BAR_CHART_COLOR_ELNAT_EFFEKT = "#CC9900";
export const BAR_CHART_COLOR_ELNAT_FAST = "#80350E";
export const BAR_CHART_COLOR_ELNAT_OVERFORING = "#FFD700";
export const BAR_CHART_COLOR_ELSKATT = "#F5F5DC";
export const BAR_CHART_COLOR_FLODESKOSTNAD = "#66CDAA";
export const BAR_CHART_COLOR_FJARRVARME_EFFEKT = "#556B2F";
export const BAR_CHART_COLOR_ENERGI = "#228B22";
export const BAR_CHART_COLOR_DRIFT_UNDERHALL = "#BEBEBE";
export const BAR_CHART_COLOR_KAPITALKOSTNAD = "#FFA500";
export const BAR_CHART_COLOR_EXTRA_REINVESTERING = "#CD853F";
export const BAR_CHART_COLOR_EXTRA_FJARRVARMESPETS = "#9370DB";
